"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var IconButton = require("../../../components/Input/IconButton");
/**
 * アラート表示用コンポーネント
 * @param severity 重要度 info | error (デフォルト:info)
 * @param message 表示メッセージ
 * @param onClose クローズボタンイベント
 * @param buttons メッセージ下のアクション用ボタン（複数許容、ボタンエレメントを配列で渡す）
 */
var Alert = function (_a) {
    var _b = _a.severity, severity = _b === void 0 ? 'info' : _b, message = _a.message, _c = _a.onClose, onClose = _c === void 0 ? null : _c, _d = _a.buttons, buttons = _d === void 0 ? [] : _d;
    var _e = (0, react_1.useState)(false), closed = _e[0], setClosed = _e[1];
    var handleClose = function (e) {
        onClose && onClose(e);
        setClosed(true);
    };
    return !closed ? ((0, jsx_runtime_1.jsxs)(material_1.Alert, { icon: false, severity: severity, sx: {
            position: 'relative',
            py: 7,
            pl: { xs: 6, md: 7 },
            pr: { xs: 5, md: 9 },
            m: { xs: 4, md: 7 },
            borderRadius: 3,
            boxSizing: 'border-box',
        }, children: [(0, jsx_runtime_1.jsx)(IconButton.Close, { onClick: handleClose, sx: {
                    position: 'absolute',
                    top: 12,
                    right: 12,
                } }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gridGap: 20,
                }, children: [(0, jsx_runtime_1.jsx)(material_1.AlertTitle, { sx: {
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                        }, children: message }), buttons.length >= 1 && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 4,
                            width: '100%',
                            justifyContent: { xs: 'center', md: 'start' },
                        }, children: buttons.map(function (el) { return el; }) }))] })] })) : null;
};
exports.Alert = Alert;
